import {Component, EventEmitter, Injector, OnInit, Output} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {UserService} from "../dashboard/services/user.service";
import {ParameterService} from "../../_services/parameter.service";
import {AddUserCertificationModal} from "./modals/add-user-certification.modal";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {InformationDialog} from "../../_shared/dialog/information.dialog";

@Component({
    selector: 'my-wallet-certification',
    templateUrl: './certification-list.component.html',
})
export class CertificationListComponent extends BasePageComponentDirective<any> implements OnInit {
    userCerts: any[] = [];
    attendanceTypes: any = {};
    @Output() getNumberCert = new EventEmitter();
    @Output() refreshCeuCredit = new EventEmitter();
    constructor(
        injector: Injector,
        private userService: UserService,
        private parameterService: ParameterService,
    ) {
        super(injector);
    }
    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['title'];
        this.userService.getUserCertifications(this.pageQuery).then(r => {
            this.userCerts = r.content;
            this.page.emit(r);
            this.getNumberCert.emit(this.totalRow);

        });
    }

    override async ngOnInit():Promise<void> {
        super.ngOnInit();
        this.attendanceTypes = await this.parameterService.getParameterByName("ATTENDANCE_TYPE");
        this.query();
    }

    updateCertification(cert: any) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(AddUserCertificationModal, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                mode: 'edit',
                provider: cert.certification.association.id,
                title: cert.certification.title,
                id: cert.certification.id,
                acquiredDate: cert.acquiredDate,
                attendanceType: cert.attendanceType,
                providerAssignedId: cert.providerAssignedId,
                earnedCertificationId: cert.id.id
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.query();
            }
        })
    }

}
